import { render, staticRenderFns } from "./groupGoods.module.vue?vue&type=template&id=4b3d9de1&scoped=true"
import script from "./groupGoods.module.vue?vue&type=script&lang=js"
export * from "./groupGoods.module.vue?vue&type=script&lang=js"
import style0 from "./groupGoods.module.vue?vue&type=style&index=0&id=4b3d9de1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d9de1",
  null
  
)

export default component.exports